const desktopPadding = '25px 25px 35px 25px'
const mobilePadding = '20px 15px 25px 15px'

export default makeStyles((theme) => ({
  gridMap: ({ desktop }) => ({
    padding: '0',
    height: desktop ? 400 : 250,
    minHeight: desktop ? 400 : 250,
  }),
  gridClear: ({ desktop }) => ({
    backgroundColor: theme.palette.primary.light,
    padding: desktop ? desktopPadding : mobilePadding,
  }),
  gridBg: {
    paddingBottom: 0,
  },
  signupBg: ({ desktop }) => ({
    backgroundColor: '#26303c',
    padding: desktop ? desktopPadding : mobilePadding,
    paddingTop: 50,
    paddingBottom: 70,
    margin: 0,
  }),
}))
